import { defineComponent as n, computed as o, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "13bf1346-171a-4967-80f2-a11ee377035a" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#13bf1346-171a-4967-80f2-a11ee377035a)" }, k = { key: 0 }, g = /* @__PURE__ */ t("path", {
  fill: "#6da544",
  d: "M0 0v512h160l96-64 96 64h160V0H352l-96 64-96-64Z"
}, null, -1), p = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "M160 0h192v512H160Z"
}, null, -1), v = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ n({
  __name: "ng",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const e = a, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), c = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (i(), r("title", k, d(e.flagName), 1)) : f("", !0),
        g,
        p
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: _({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=ng-1cd9eb87.js.map
